module.exports = __webpack_public_path__ + "media/images/home/logo3-3bcfe0c5c1e3f59c4c822b12324b4fdc.png";